import ApiConnection from "../ApiConnection";

export const Delete = () => {
    return ApiConnection.delete('/me/sessions');
};
